import styled from "styled-components";

export const Content = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 15px;
	background-color: ${({ theme }) => theme.white};
	padding: 10px 20px 15px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.grayLight};
	margin: 20px;
	max-width: 100%;

	> h6 {
		width: 100%;
		max-width: 600px;
	}
`;

export const TitleModal = styled.h2`
	font-weight: bold;
	font-size: 1rem;
	text-align: center;
	margin: 0;
	&& {
		width: 100%;
		white-space: normal;
	}
`;

export const FooterText = styled.p`
	font-size: 0.8rem;
	text-align: center;
	max-width: 70%;
	margin: 0 auto;

	@media (max-width: 720px) {
		max-width: 80%;
	}
`;

export const CellContent = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	white-space: normal;
`;

export const ContainerCloseButton = styled.div`
	position: absolute;
	top: 7px;
	right: 15px;
`;
